import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@assets/css/reset.css'

import AMap from 'vue-amap';
import ElementUI from 'element-ui';
import '@/theme/element/theme/index.css';
import "./mixin"
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(ElementUI);
Vue.use(AMap);
Vue.config.productionTip = false

Vue.use(require("vue-moment"))

AMap.initAMapApiLoader({
  // 高德key
  key: 'a78455d8f43883f1024c8477586af91b',
  // 插件集合(插件按需引入)
  plugin: [
    "AMap.Autocomplete",    //输入提示插件
    "AMap.PlaceSearch",     //POI搜索插件
    "AMap.Scale",           //右下角缩略图插件 比例尺
    "AMap.OverView",        //地图鹰眼插件
    "AMap.ToolBar",         //地图工具条
    "AMap.PolyEditor",      //编辑 折线多，边形
    "AMap.CircleEditor",    //圆形编辑器插件
    "AMap.Geolocation"      //定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
});



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
